/* ----- The engine. answers -> composed ritual. Pure, no globals touched. ----- */
function composeRitual(answers){
  const a=answers||[];
  const decisions=[];const D=t=>decisions.push(t);
  const tex=(a[2]&&a[2].length)?a[2][0]:undefined;           /* Q3 */
  const t4=(a[3]&&a[3].length)?a[3][0]:2;                    /* Q4 */
  const timing=t4===0?"am":t4===1?"pm":"both";
  const simple=(a[4]||[]).includes(0);                       /* Q5 */
  const eyes=(a[5]||[]).includes(0);                         /* Q6 */
  const q7=(a[6]&&a[6].length)?a[6][0]:undefined;            /* Q7 */

  const path=basePath(a,D);
  const daySeal=chooseDaySeal(path,tex,q7,D);
  const eveSeal=chooseEveSeal(path,tex,q7,daySeal,D);

  if(timing==="am")D("Mornings only, as asked: no evening steps appear in this ritual.");
  else if(timing==="pm")D("Evenings only, as asked: no morning steps and no SPF line appear.");
  else D("Both sittings are yours: a ritual in two lights.");
  if(simple)D("A simple edit, as asked: the optional layers are set aside.");
  else D("A complete ritual, as asked: the optional layers join where the path allows them.");
  if(eyes&&path!=="rocco")D("The eye area is included because you asked us to keep it in mind.");
  if(eyes&&path==="rocco")D("The eye pair sits out of the shave edit, which stays calm and simple on purpose.");

  const S=(k,role,why,slot,opt)=>({k,role,why,slot,opt:!!opt});
  const am=[],pm=[];
  const NIGHT_ONLY=["moonlit","sealavender","orchid","splendid","alpine","miracle"];

  /* v1.0A: shared pieces */
  const RESTRAINT="For this edit, we chose the essentials. The ritual stays intentionally restrained while honoring the qualities you told us matter most.";
  const q1a=a[0]||[];
  const q2a=(a[1]&&a[1].length)?a[1][0]:undefined;
  const orchidStep=core=>S("orchid","The overnight infusion","A velvety overnight milk of rare orchid, copper peptide, and silk: replenishing moisture through the quiet hours, always before your moisturizer closes the night.","infusion",!core);

  /* eye pair, gated by Question VI, available on every path except the shave edit */
  const eyeSteps=()=>{
    const s=[S("clever","The eye area","You asked this ritual to account for the eye area: a silky peptide serum to leave the eye contour looking luminous and refreshed, applied before your final step.","eye")];
    if(!simple)s.push(S("erase","The eye reset","For mornings that follow late nights: a targeted mask kept nearby to refresh the look of the eye contour before the day begins.","eye",true));
    return s;
  };

  if(path==="elena"){
    const swissCore=q7===4;
    if(swissCore)D("You asked to finish calm and resilient, so the comfort serum joins even the simple edit.");
    /* v1.0A founder correction: every signature devotion carries the signature formula, so the Balanced and Softness doors open at every ritual depth; the calm finish keeps its precedence */
    const petalsDoor=!swissCore&&(q1a.includes(6)||q2a===2);
    if(petalsDoor)D(q2a===2?"Softness is the devotion, so the signature serum takes the serum step: the look of bounce is how the house composes skin you want to touch.":"You told us your skin is balanced and you want more, so the signature serum takes the serum step.");
    /* v1.0A: Orchid joins evening sittings; silky promotes it into the simple edit unless the signature serum holds that step; weightless never carries a milk */
    const orchidCore=simple&&tex===1&&!swissCore&&!petalsDoor;
    const orchidJoin=timing!=="am"&&tex!==0&&(!simple||orchidCore);
    if(orchidCore&&orchidJoin)D("Silky, as asked: the overnight infusion milk is exactly that texture, so it joins even the simple edit.");
    if(simple&&tex===1&&swissCore&&timing!=="am")D(RESTRAINT);
    if(simple&&petalsDoor&&tex===1&&timing!=="am")D(RESTRAINT);
    const core=[S("superfruit","The cleanse","Because your mornings should not slow down, we open with a featherlight gel that gathers the night off your skin with one sweep of a cotton pad. No rinsing, no tightness, no fuss.","cleanse")];
    if(petalsDoor)core.push(S("petals","The signature serum","A golden peptide concentrate, the signature serum of the house, devoted to the look of firmness, bounce, and skin you want to touch. Worn at every sitting, then always followed by your moisturizer.","anchor"));
    else if(!simple||swissCore)core.push(S("swiss","The comfort serum","A ferment-rich comfort layer pressed in before your moisturizer, for days when skin wants a little more reassurance.","anchor",!swissCore));
    if(timing==="both"&&(eveSeal!==daySeal||orchidJoin)){
      am.push(...core,S(daySeal,"The daytime seal",sealWhy(daySeal,path,tex,"am"),"seal"));
      pm.push(...core.map(x=>({...x})));
      if(orchidJoin)pm.push(orchidStep(orchidCore));
      pm.push(S(eveSeal,"The evening seal",sealWhy(eveSeal,path,tex,"pm"),"seal"));
    }else{
      const seal=timing==="pm"?eveSeal:daySeal;
      const list=[...core];
      if(orchidJoin&&timing==="pm")list.push(orchidStep(orchidCore));
      list.push(S(seal,"The seal",sealWhy(seal,path,tex,timing==="pm"?"pm":"am"),"seal"));
      (timing==="pm"?pm:am).push(...list);
    }
    if(eyes&&timing!=="pm")am.push(...eyeSteps());
    if(eyes&&timing==="pm")pm.push(...eyeSteps());
  }

  if(path==="sofia"){
    /* v1.0A: Orchid joins complete evening sittings; the calm anchor is core, so the simple edit holds three steps and stays restrained */
    const orchidJoin=timing!=="am"&&tex!==0&&!simple;
    if(simple&&tex===1&&timing!=="am")D(RESTRAINT);
    const core=[
      S("frangipani","The cleanse","A soft, cushioning cream that undoes the day gently and rinses clean. One pump, one slow minute.","cleanse"),
      S("swiss","The anchor","You told us your skin reacts quickly. This ferment-rich comfort complex was composed for exactly those days, so stressed skin can settle into calm. Worn at every sitting.","anchor")
    ];
    if(timing==="both"&&(eveSeal!==daySeal||orchidJoin)){
      am.push(...core,S(daySeal,"The daytime seal",sealWhy(daySeal,path,tex,"am"),"seal"));
      pm.push(...core.map(x=>({...x})));
      if(orchidJoin)pm.push(orchidStep(false));
      pm.push(S(eveSeal,"The evening seal",sealWhy(eveSeal,path,tex,"pm"),"seal"));
    }else{
      const seal=timing==="pm"?eveSeal:daySeal;
      const list=[...core];
      if(orchidJoin&&timing==="pm")list.push(orchidStep(false));
      list.push(S(seal,"The seal",sealWhy(seal,path,tex,timing==="pm"?"pm":"am"),"seal"));
      (timing==="pm"?pm:am).push(...list);
    }
    if(eyes)(timing==="pm"?pm:am).push(...eyeSteps());
  }

  if(path==="rocco"){
    const list=[
      S("frangipani","The cleanse","A cushioning cream cleanse that never drags across freshly shaved skin.","cleanse"),
      S("swiss","The comfort serum","Pressed in after cleansing, so skin that has just met a blade can settle before it is sealed.","anchor"),
      S("mens","The seal",sealWhy("mens",path,tex,"am"),"seal")
    ];
    (timing==="pm"?pm:am).push(...list);
  }

  if(path==="daniela"){
    if(timing!=="pm"){
      am.push(
        S("frangipani","The cleanse","A gentle cream start that leaves skin calm and supple.","cleanse"),
        S("marinelumina","The anchor","Light, drawn from the deep: a brightening serum composed to soften the look of uneven tone and revive radiance exactly where dullness sets in.","anchor")
      );
      if(!simple)am.push(S("magnolia","The morning treatment layer","A daytime luminance layer that drapes skin in a weightless veil of morning dew, always followed by your moisturizer.","treat",true));
      else if(q7===3)D("The luminous finish you asked for lives most fully in the complete ritual’s morning luminance layer, waiting whenever you want it.");
      am.push(S(daySeal,timing==="both"?"The seal":"The seal",sealWhy(daySeal,path,tex,"am"),"seal"));
      if(eyes)am.push(...eyeSteps());
    }
    if(timing==="pm"){
      pm.push(S("frangipani","The cleanse","The same gentle cream cleanse closes the day and undoes it.","cleanse"));
      if(!simple)pm.push(S("splendid","The preparation","Two or three evenings a week to begin, built gradually toward a nightly rhythm: quiet, cumulative surface renewal cushioned in damask rose and marshmallow root, clearing daily accumulation so the brightening serum meets freshly prepared skin. Your skin may take a little time to adjust. Consistency matters more than intensity.","prep",true));
      pm.push(S("marinelumina","The anchor","The brightening serum returns for the evening sitting, unhurried, on freshly prepared skin.","anchor"));
      if(!simple&&tex===1){D("Silky, as asked: in the complete ritual, the infusion milk joins the evening after the brightening serum.");pm.push(orchidStep(false));}
      pm.push(S(eveSeal,"The evening seal",sealWhy(eveSeal,path,tex,"pm"),"seal"));
      if(eyes)pm.push(...eyeSteps());
    }else if(timing==="both"){
      if(!simple)pm.push(S("splendid","The preparation","Cleanse as above, then the preparation before the serum: two or three evenings a week to begin, built gradually toward a nightly rhythm. Quiet, cumulative surface renewal clears daily accumulation so Marine Lumina meets freshly prepared skin; the seal then closes the night. Your skin may take a little time to adjust. Consistency matters more than intensity.","prep",true));
      if(!simple&&tex===1){
        D("Silky, as asked: in the complete ritual, the infusion milk joins the evening before the seal.");
        pm.push(orchidStep(false));
        pm.push(S(eveSeal,"The evening seal",sealWhy(eveSeal,path,tex,"pm"),"seal"));
      }else if(eveSeal!==daySeal)pm.push(S(eveSeal,"The evening seal",sealWhy(eveSeal,path,tex,"pm"),"seal"));
    }
    if(timing==="am")D("The resurfacing evenings wait until you invite them; nothing of the night appears in a morning ritual.");
  }

  if(path==="bianca"){
    if(timing!=="pm"){
      am.push(
        S("frangipani","The cleanse","A calm cream cleanse to open the day.","cleanse"),
        S("swiss","The daily anchor","Balance is kept, not forced: the comfort complex holds the daily rhythm so the resets never have to work alone. Swiss maintains.","anchor"),
        S("illume","The seal",sealWhy("illume",path,tex,"am"),"seal")
      );
      if(eyes)am.push(...eyeSteps());
    }
    if(timing==="pm"){
      pm.push(S("frangipani","The cleanse","A calm cream cleanse to close the day.","cleanse"));
      if(!simple){
        pm.push(
          S("splendid","The preparation","Quiet, cumulative surface renewal, begun two or three evenings a week and built gradually toward a nightly rhythm, clearing surface buildup so skin meets its reset freshly prepared. Your skin may take a little time to adjust. Consistency matters more than intensity.","prep",true),
          S("alpine","The reset: two or three evenings a week","On those evenings, Alpine takes the serum step in place of the comfort complex, so each evening carries one treatment step. The order is exact: the preparation step, then Alpine, then the glass-skin gel. Alpine resets; on the other evenings, Swiss maintains.","anchor",true)
        );
      }else{
        pm.push(S("swiss","The daily anchor","The comfort complex holds the evening as it holds the day. Swiss maintains.","anchor"));
      }
      pm.push(S("illume","The evening seal",sealWhy("illume",path,tex,"pm"),"seal"));
      if(eyes)pm.push(...eyeSteps());
    }else if(timing==="both"&&!simple){
      pm.push(
        S("splendid","The preparation","Cleanse, then the preparation: quiet, cumulative surface renewal, begun two or three evenings a week and built gradually toward a nightly rhythm, clearing surface buildup so skin meets its reset freshly prepared. Your skin may take a little time to adjust. Consistency matters more than intensity.","prep",true),
        S("alpine","The reset: two or three evenings a week","On those evenings, Alpine takes the serum step in place of the comfort complex, so each evening carries one treatment step. The order is exact: the preparation step, then Alpine, then the glass-skin gel. Alpine resets; on the other evenings, Swiss maintains.","anchor",true)
      );
    }
    if(timing==="am")D("The evening correction rhythm waits until you invite it; mornings stay light and kept.");
  }

  if(path==="mara"){
    if(timing!=="pm"){
      am.push(
        S("frangipani","The cleanse","The gentlest possible open: nothing that asks tired skin to work.","cleanse"),
        S("swiss","The daily anchor","Resilience is rebuilt on quiet days: the ferment-rich comfort complex holds the daily rhythm while the hero does its overnight work.","anchor"),
        S(daySeal,"The daytime seal",sealWhy(daySeal,path,tex,"am"),"seal")
      );
      if(eyes)am.push(...eyeSteps());
    }
    if(timing!=="am"){
      if(timing==="pm")pm.push(
        S("frangipani","The cleanse","The gentlest possible close: nothing that asks tired skin to work.","cleanse"),
        S("swiss","The daily anchor","The comfort complex holds the evening as it holds the day, while the hero below does its overnight work.","anchor")
      );
      pm.push(
        S("sealavender","The hero: the overnight resilience seal","Two or three nights a week, or whenever skin feels worn down, this jelly IS the final step. Nothing goes over it, and no other moisturizer goes underneath. Wake to skin that feels calmer and more resilient.","seal-hero"),
        S("moonlit","The seal on ordinary nights","A plush night cream for the evenings in between. One seal per night, always: on Sea Lavender nights, the jelly stands alone. Resurfacing waits until resilience returns; this path never reaches for the balance reset.","seal")
      );
      if(!simple)pm.push(S("miracle","Special care, once a week","An opulent butter gel that melts on contact, used once a week as a masque, or as a targeted balm wherever skin feels depleted. It never replaces the evening seal.","treat",true));
      if(eyes&&timing==="pm")pm.push(...eyeSteps());
    }else{
      D("The hero of this path is an overnight jelly seal; it waits for you in the evenings, whenever they open up, so your morning ritual stays true to morning.");
    }
  }

  if(path==="petra"){
    if(timing!=="pm"){
      am.push(
        S("frangipani","The cleanse","A soft cream open.","cleanse"),
        S("petals","The anchor","A golden peptide concentrate devoted to the look of firmness: a true treatment serum, worn at every sitting, then always followed by your moisturizer.","anchor")
      );
      if(!simple){
        am.push(
          S("magnolia","The morning treatment layer","A daytime luminance layer that follows the peptide serum, draping skin in a weightless veil of morning dew before your moisturizer.","treat",true),
          S(daySeal,"The daytime seal",sealWhy(daySeal,path,tex,"am"),"seal",true)
        );
      }
      if(eyes)am.push(...eyeSteps());
    }
    if(timing!=="am"){
      if(timing==="pm")pm.push(S("frangipani","The cleanse","A soft cream close.","cleanse"));
      if(!simple)pm.push(S("splendid","The preparation","Two or three evenings a week to begin, built gradually toward a nightly rhythm: quiet, cumulative surface renewal that clears daily accumulation so the peptide serum meets freshly prepared skin. Your skin may take a little time to adjust. Consistency matters more than intensity.","prep",true));
      if(timing==="pm")pm.push(S("petals","The anchor","The peptide serum returns for the quiet hours on freshly prepared skin, then is always followed by your moisturizer.","anchor"));
      /* v1.0A: the absolute three-step rule governs every simple edit; the former silky promotion is retired here and the restraint note speaks instead */
      if(simple&&tex===1)D(RESTRAINT);
      if(!simple&&tex!==0)pm.push(S("orchid","The overnight infusion","An overnight treatment milk that follows the peptide serum: replenishing moisture through the quiet hours, always before the cocoon cream.","infusion",true));
      pm.push(S("moonlit","The evening seal","Cocooning: a plush cream to close the night over the peptide serum.","seal"));
      if(eyes&&timing==="pm")pm.push(...eyeSteps());
    }else{
      D("The evening chapter, with its infusion and cocoon, waits until evenings are yours.");
    }
  }

  /* ----- chapters ----- */
  const chapters=[];
  if(am.length)chapters.push({head:(pm.length||timing==="am")?(pm.length?"Morning":null):null,items:am,spf:true});
  if(pm.length)chapters.push({head:am.length?"Evening":null,items:pm,spf:false});
  /* single-chapter both-sittings paths keep no head; spf shows when mornings are included */
  if(chapters.length===1){chapters[0].head=null;chapters[0].spf=timing!=="pm";}

  /* ----- title, told, lines ----- */
  const fixed={mara:"Ritual",rocco:"Edit"}[path]||null;
  const baseName=PATH_NAMES[path];
  if(path==="elena")D(daySeal==="illume"?"Everyday Comfort is the ritual; your texture answer sets its finish. Today that finish is fresh: the glass-skin gel closes each sitting.":"Everyday Comfort is the ritual; your texture answer sets its finish. Today that finish is cushion: the deeply hydrating cream closes the day.");
  const title=baseName+" "+(fixed||(simple?"Edit":"Ritual"));
  const TOLD={
    elena:"You told us your skin can feel tight or thirsty by afternoon, and that comfort is the devotion.",
    sofia:"You told us your skin is easily overwhelmed, reacting quickly, and that comfort is what this ritual should protect.",
    daniela:"You told us your skin has been looking dull and a little uneven, and luminosity is the point.",
    bianca:"You told us your skin has been feeling congested and prone to shine, and that balance, skin that behaves, is the devotion.",
    mara:"You told us your skin feels worn down, depleted, and less resilient than usual. Resilience is the ruling truth of this ritual.",
    petra:"You told us your skin feels balanced but you want more: the look of firmness.",
    rocco:"You told us your skin is frequently shaved, so this ritual stays calm, cool, and simple on purpose."
  };
  const TEXCLAUSE={0:" You love textures you can barely feel.",1:" You asked for silky, fluid textures.",2:" You asked for cushion, deeply hydrating and never greasy.",3:" You asked for rich, cocooning textures.",4:" You left the textures to the house."};
  let told=TOLD[path];
  if(tex!==undefined)told+=TEXCLAUSE[tex];
  if(timing==="am")told+=" Mornings are yours, so this ritual lives in the first light.";
  if(timing==="pm")told+=" Evenings are yours, so this ritual keeps to the quiet hours.";
  if(q7!==undefined)told+=" And when it is complete, your skin should feel "+FINISH[q7]+".";
  const timingLine=chapters.length>1?"A ritual in two lights · morning &amp; evening":(timing==="am"?"Composed for your mornings":timing==="pm"?"Composed for your evenings":null);

  /* ----- sequence line, generated from the final steps ----- */
  const seq=chapters.map(c=>{
    const label=c.head==="Morning"?"Mornings:":c.head==="Evening"?"Evenings:":(timing==="am"?"Each morning:":timing==="pm"?"Each evening:":"Morning and evening:");
    const names=[],extras=[];
    c.items.forEach(it=>{
      if(it.slot==="eye")return;
      if(it.k==="splendid"){extras.push("The preparation step joins two or three evenings a week to begin, after cleansing and before the serum step.");return;}
      if(it.k==="alpine"){extras.push("Alpine takes the serum step two or three evenings a week; the comfort complex holds the others.");return;}
      if(it.k==="sealavender"){extras.push("Sea Lavender is the final step two or three nights a week, or whenever skin feels worn down.");return;}
      if(it.k==="moonlit"&&path==="mara"){extras.push("The cocoon cream closes the ordinary nights.");return;}
      if(it.k==="miracle"){extras.push("The butter gel is a once-a-week masque, never the seal.");return;}
      names.push(SHORT[it.k]);
    });
    let s=names.length?label+" "+names.join(", ")+".":label.replace(":"," belongs to its own rhythm:");
    if(extras.length)s+=" "+extras.join(" ");
    if(c.spf)s+=" For daytime rituals, finish with your preferred SPF.";
    return s;
  }).join(" ");

  /* ----- bench and enhance ----- */
  const productsIn=[...new Set(chapters.flatMap(c=>c.items.map(i=>i.k)))];
  const BENCH_PREF={elena:["petals",daySeal,"swiss"],sofia:["swiss",daySeal],daniela:["marinelumina",daySeal,eveSeal],bianca:["alpine","swiss"],mara:["sealavender","swiss","luscious"],petra:["petals","orchid"],rocco:["mens"]};
  let bench=(BENCH_PREF[path]||[]).filter(k=>productsIn.includes(k)&&BENCH[k]).slice(0,2);
  if(!bench.length)bench=productsIn.filter(k=>BENCH[k]).slice(0,1);

  const enhance=[];
  /* v1.0A: Keys is special care on a glow signal, never filler */
  if(path==="daniela"||((path==="elena"||path==="petra")&&q7===3))enhance.push({k:"keys",text:"Fifteen minutes before an occasion, for plumper-looking skin."});
  if(path==="bianca")enhance.push({k:"hemp",text:"Once a week where shine gathers: a ten-minute mineral clay reset, rinsed clean."});
  if(path==="mara"&&(simple||timing==="am"))enhance.push({k:"miracle",text:"Where skin craves deep nourishment: an opulent butter gel that melts on contact, used as a weekly masque or a targeted balm wherever skin feels depleted. It never replaces the evening seal."});
  if(path==="petra")enhance.push({k:"miracle",text:"For the evenings you want indulgence itself: a melting butter gel masque of rare butters, used as its own quiet moment rather than layered into the ritual."});

  return {path,title,base:PATH_NAMES[path],told,timing,timingLine,simple,eyes,tex,q7,chapters,seq,bench,enhance,decisions,
    morning:chapters.filter(c=>c.head==="Morning"||(!c.head&&timing!=="pm")).flatMap(c=>c.items.map(i=>i.k)),
    evening:chapters.filter(c=>c.head==="Evening"||(!c.head&&timing!=="am")).flatMap(c=>c.items.map(i=>i.k)),
    addons:[...new Set([...chapters.flatMap(c=>c.items.filter(i=>i.slot==="eye").map(i=>i.k)),...enhance.map(e=>e.k)])]
  };
}

